var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({class:[_vm.classes, {'statusLamp__': true}],style:(("width: 20px; height: 20px; border-radius: 50%; background-color: " + _vm.color))},on))]}}])},[_c('span',{staticClass:"statusLamp--text",domProps:{"textContent":_vm._s(_vm.statusText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }